import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { defaultTheme } from 'shared/theme/theme';

const FooterWrapper = styled.footer`
  align-items: center;
  padding: 0 1em;
  font-size: 1em;
  position: relative;
  clear: both;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-top: 0.1875em solid ${defaultTheme.colors.aux.portlandOrange};
`;

const OptumLogo = styled.img`
  display: inline;
  width: 4.68em;
  margin-left: 0.5em;
  vertical-align: middle;
`;

const FooterLink = styled.a`
  text-decoration: underline;
  color: ${p => p.theme.colors.aux.brightNavyBlue};
  font-family: 'OptumSans';
  font-weight: 100;
  font-style: normal;
  border: 0.156em solid transparent;
  padding: 0.5em;
  &:hover {
    border: 0.156em solid ${p => p.theme.colors.aux.portlandOrange};
    border-radius: 0.3125em;
    padding: 0.5em;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const FooterLinksIcon = styled(Icon).attrs({
  icon: 'NewWindow',
  height: '15',
  width: '35',
})`
  padding-left: 1em;
  fill: ${p => p.theme.colors.aux.darkGrey};
`;

const Copyright = styled.div`
  margin-left: auto;
  font-family: 'OptumSans';
  color: ${p => p.theme.colors.aux.darkGrey};
`;

const Divider = styled.div`
  color: ${defaultTheme.colors.aux.lightGrey};
  background-color: ${defaultTheme.colors.aux.lightGrey};
  height: 90%;
  border-width: 0;
  width: 1px;
  float: left;
`;

const PoweredByWrapper = styled.div`
  padding-right: 3em;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledDivider = styled(Divider)`
  margin-left: 2em;
`;

class Footer extends PureComponent {
  render() {
    const { privacyLink, termsLink, logo } = this.props;
    return (
      <FooterWrapper>
        <PoweredByWrapper>
          <OptumLogo src={logo} alt="Optum Logo" />
          <StyledDivider />
        </PoweredByWrapper>
        <FooterLinks>
          <FooterLink href={termsLink} target="_blank">
            Terms of Use
            <FooterLinksIcon />
          </FooterLink>
          <FooterLink href={privacyLink} target="_blank">
            Privacy Policy
            <FooterLinksIcon />
          </FooterLink>
        </FooterLinks>
        <Copyright>
          &copy;{new Date().getFullYear()} Optum, Inc. All rights reserved
        </Copyright>
      </FooterWrapper>
    );
  }
}

Footer.defaultProps = {
  privacyLink: '/privacy',
  termsLink: '/terms',
  logo: 'https://cdn.linkhealth.com/images/New-Optum-Logo.png',
};

Footer.propTypes = {
  privacyLink: PropTypes.string,
  termsLink: PropTypes.string,
  logo: PropTypes.string,
};

export default Footer;
